import { useSelector } from 'react-redux'

import { useLockableComponent } from '~/store/hooks/soap'
import { getAppointmentId } from '~/store/reducers/soap'
import { getTimetableEvent } from '~/store/reducers/timetable'

import ReasonForVisitWidgetLocked from './ReasonForVisitWidgetLocked'
import ReasonForVisitWidgetUnlocked from './ReasonForVisitWidgetUnlocked'

const ReasonForVisitWidget = () => {
  const appointmentId = useSelector(getAppointmentId)
  const appointment = useSelector(getTimetableEvent(appointmentId))

  const ReasonForVisitWidgetComponent = useLockableComponent(
    ReasonForVisitWidgetUnlocked,
    ReasonForVisitWidgetLocked,
  )

  if (!appointment) {
    return null
  }

  return (
    <ReasonForVisitWidgetComponent
      appointmentId={appointment.id}
      appointmentNotes={appointment.notes}
    />
  )
}

export default ReasonForVisitWidget
